import axios from 'axios';
import {  config } from '_constants';
import {storeConstants} from "store";
import { authHeader } from '_helpers';

export const getReviewsStart = (token = void 0) => {
    return {
        type: storeConstants.REVIEWS_GETALL_REQUEST,
        token: token
    };
};

export const getReviewsFail = (error) => {
    return {
        type: storeConstants.REVIEWS_GETALL_FAILURE,
        error: error.message? error.message : error.toString()
    };
};


export const getReviewsSuccess = (items) => {
    return {
        type: storeConstants.REVIEWS_GETALL_SUCCESS,
        items: items
    };
};

export const getReviews = () => {
    return dispatch => {
        dispatch(getReviewsStart());
        let url = `${config.API_URL}/Reviews`;

        axios.get(url,{ headers: authHeader() })
            .then(res => {
                 const fetchedData = [];
                for (let key in res.data) {
                    fetchedData.push({
                        ...res.data[key],
                        id: key
                    });
                }
                dispatch(getReviewsSuccess(fetchedData));
            })
            .catch(err => {
                dispatch(getReviewsFail(err));
            });
    }
}